<ion-list class="ion-hide-md-down">
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/tabs/dashboard"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/dashboard_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>Dashboard</ion-label>
    </ion-item>
  </ion-menu-toggle>
</ion-list>

@if (canCreateDeca()) {
  <ion-list>
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.NEW"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/qr_code_2_add_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Nuevo documento</ion-label>
      </ion-item>
    </ion-menu-toggle>
  </ion-list>
}

@if (canViewDecaAsShipper()) {
  <ion-list>
    <ion-item>
      <ion-label class="ion-text-uppercase">
        <strong>Cargador</strong>
      </ion-label>
    </ion-item>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.SHIPPER_UPCOMING"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okc_qr_current_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Documentos vigentes</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.SHIPPER_PAST"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/snippet_folder_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Archivados</ion-label>
      </ion-item>
    </ion-menu-toggle>
  </ion-list>
}

@if (canViewDecaAsCarrier()) {
  <ion-list>
    <ion-item>
      <ion-label class="ion-text-uppercase">
        <strong>Transportista</strong>
      </ion-label>
    </ion-item>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.CARRIER_UPCOMING"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/qr_code_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Documentos vigentes</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.CARRIER_PAST"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okc_folder_qr_code_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Archivados</ion-label>
      </ion-item>
    </ion-menu-toggle>
  </ion-list>
}

<ion-list>
  <ion-item>
    <ion-label class="ion-text-uppercase">
      <strong>Gestión</strong>
    </ion-label>
  </ion-item>

  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/my-company"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/domain_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'company.my_company' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>

  <!-- TODO move to 'my company' page -->
  <!-- <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/billing-shipper"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/payments_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.billing' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle> -->

  @if (canCreateDeca()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/contact-book"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/group_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Libreta de contactos</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }

  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/account"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/account_circle_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.account' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
</ion-list>
